import { mutatorAction } from 'satcheljs';
import {
    MailboxInfo,
    MailboxType,
    getUserMailboxInfo,
    getDefaultRoutingKey,
    getRoutingKeyPrefixForSmtpAddress,
} from 'owa-client-ids';
import { getFolderTable, getDefaultRequestOptions } from 'owa-folders';
import { SHARED_FOLDERS_TREE_TYPE } from 'owa-folders-constants';
import getStore from '../store/store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Utility which returns user mailbox info as per folder id
 * @param folderId
 */
export default function fetchUserMailboxInfoFromFolderId(folderId: string): MailboxInfo {
    // Return request options as default mailbox info if folderId is not present
    if (!folderId) {
        return getUserMailboxInfo();
    }

    // Save recomputation by storing the request options in a map per folder
    if (!getStore().has(folderId)) {
        let mailboxInfo = GetUserMailboxInfoUsingFolderId(folderId);
        addToStore(folderId, mailboxInfo);
    }

    return getStore().get(folderId);
}

/**
 * Fetches user mailbox id for a given folder id
 * @param folderId
 */
function GetUserMailboxInfoUsingFolderId(folderId: string): MailboxInfo {
    const folderTable = getFolderTable();
    const folder = folderTable && folderTable.get(folderId);

    let mailboxSmtpAddress: string;
    let routingKey: string;

    if (folder && folder.treeType === SHARED_FOLDERS_TREE_TYPE) {
        mailboxSmtpAddress = folder.principalSMTPAddress;
        routingKey = getRoutingKeyPrefixForSmtpAddress() + folder.principalSMTPAddress;
    } else {
        // oneMailView - folder cleanup
        mailboxSmtpAddress = getUserConfiguration().SessionSettings.UserEmailAddress;
        routingKey = getDefaultRoutingKey();
    }

    return {
        type: MailboxType.UserMailbox,
        userIdentity: mailboxSmtpAddress,
        mailboxSmtpAddress: mailboxSmtpAddress,
        routingKey: routingKey,
        requestOptions: getDefaultRequestOptions(folderId),
    };
}

const addToStore = mutatorAction(
    'addMailboxInfoToStore',
    (folderId: string, mailboxInfo: MailboxInfo) => {
        getStore().set(folderId, mailboxInfo);
    }
);
